module.exports = __webpack_public_path__ + "static/app-footer-fa60c6db29ea3cce4aaf8b01ad272f0f.svg";